module.exports = __webpack_public_path__ + "static/media/16UNODC38.a4b548d0.jpg";